module.exports = __webpack_public_path__ + "static/media/13.f4df593f.jpg";